import { FCX, getEnding, getFormattedThousand, getRem } from "@datassential/platform-ui-lib";
import { useCallback, useId, useMemo, useRef, useState } from "react";
import Dropdown from "@components/Dropdown";
import { useKeywords } from "@core/CommonDataContext";
import useOutsideClick from "@hooks/useOutsideClick";
import { IoIosArrowUp } from "react-icons/io";
import cn from "classnames";
import SlashSelect from "@components/SlashSelect";
import { useSelectedKeywordsContext } from "@vms/SelectedKeywords/SelectedKeywordsContext";

const SelectedKeywords: FCX = ({
    className,
    style,
}) => {
    const {
        selectedKeywordsIds,
        setSelectedKeywordsIds,
        toggleKeywordSelection,
        setIsSelectedKeywordsView,
    } = useSelectedKeywordsContext();
    const id = useId();
    const ref = useRef(null);
    const [isOpened, setIsOpened] = useState(false);
    useOutsideClick({
        ref,
        callback: () => setIsOpened(false),
        isDisabled: !isOpened,
    });

    const keywords = useKeywords();

    const selectedItems = useMemo(
        () => keywords.filter(
            i => selectedKeywordsIds.includes(i.id ?? 0)
        ),
        [selectedKeywordsIds, keywords]
    );

    const onRemoveAll = useCallback(
        () => {
            setSelectedKeywordsIds([]);
            setIsSelectedKeywordsView(false);
        },
        [setSelectedKeywordsIds, setIsSelectedKeywordsView]
    );

    return (
        <div
            ref={ref}
            className={cn("SelectedKeywords", className)}
            style={style}
        >
            <div
                data-tooltip-id={id}
                onClick={() => setIsOpened(!isOpened)}
                className="SelectedKeywords__thumbnail"
            >
                {getFormattedThousand(selectedKeywordsIds.length)}&nbsp;
                {getEnding('item', selectedKeywordsIds.length)} selected
                <IoIosArrowUp
                    className={cn(
                        "SelectedKeywords__thumbnail-icon",
                        isOpened && 'is-open'
                    )}
                />
            </div>
            <Dropdown
                isInPortal={false}
                id={id}
                tooltipId={id}
                isOpened={isOpened}
                className="SelectedKeywords__dropdown"
                place="top-start"
                style={{
                    maxHeight: getRem(300),
                    overflowX: 'hidden',
                }}
            >
                {selectedItems.map((item) => (
                    <div
                        key={item.id}
                        className="SelectedKeywords__dropdown-item"
                    >
                        {item.name?.toUpperCase()}
                        <div
                            className="SelectedKeywords__dropdown-item-icon"
                            onClick={() => toggleKeywordSelection(item.id ?? 0)}
                        >
                            ×
                        </div>
                    </div>
                ))}
                <div className="SelectedKeywords__dropdown-footer">
                    <SlashSelect
                        data={[
                            {
                                title: 'Clear All',
                                onClick: onRemoveAll,
                            },
                        ]}
                        testId="blockFiltersExpandCollapse"
                    />
                </div>
            </Dropdown>
        </div>
    );
};

export default SelectedKeywords;